<template>
  <div class="login">
    <div class="row">
      <div class="col-md-6 offset-md-6 content">
        <div class="login-form-sec">
        <div class="logo">
          <a href="https://www.b1g1.com">
            <link rel="stylesheet" media="all" type="text/css" href="/static/front/font_css.css">
            <img src="/static/logos/logo.png" class="logo-default" alt="alt">
          </a>
        </div>
        <div class="login-content">
          <form>
            <h3 class="form-title">Update password</h3>
            <div class="alert alert-success" role="alert" v-if="display.message">{{display.message}}</div>
            <div class="form-group" :class="{'has-error': errors.has('password') }" v-if="!display.message">
              <label class="control-label visible-ie8 visible-ie9">Password</label>
              <div class="input-icon">
                <input :type="showPassword ? 'text' : 'password'"  name="password" ref="password" v-model="form.password" v-validate="'required|password_format'" class="form-control" placeholder="Password">
                <img src="/static/images/eye.svg" class="eye-icon" @click="showPassword = !showPassword" v-if="!showPassword" alt="Show Password">
                <img src="/static/images/eye-off.svg" class="eye-icon" @click="showPassword = !showPassword" v-if="showPassword && form.password" alt="Hide Password">
              </div>
            </div>
            <div class="form-group" :class="{'has-error': errors.has('re_password') }"  v-if="!display.message">
              <label class="control-label visible-ie8 visible-ie9">Confirm Password</label>
              <div class="input-icon">
                <input :type="showConfirmPassword ? 'text' : 'password'"  name="re_password" v-model="form.re_password" v-validate="'required|confirmed:password'" class="form-control" placeholder="Confirm Password">
                <img src="/static/images/eye.svg" class="eye-icon" @click="showConfirmPassword = !showConfirmPassword" v-if="!showConfirmPassword" alt="Show Password">
                <img src="/static/images/eye-off.svg" class="eye-icon" @click="showConfirmPassword = !showConfirmPassword" v-if="showConfirmPassword" alt="Hide Password">
                <span id='passerror' style="color: red; display: none;">The password must contain minimum 8 characters with 1 letter and 1 number</span>
              </div>
            </div>
            <div class="form-actions">
              <button type="button" class="b-btn red-btn" @click="resetPassword()" :disabled="errors.count() >0 || waiting==true"  v-if="!display.message">Submit
              </button>
              <router-link :to="{name: 'login'}" v-if="display.message">
              <button type="button" class="b-btn red-btn">Login</button>
              </router-link>
            </div>
          </form>
        </div>
        <div class="copyright">Buy1Give1 @{{intYear}}</div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import userAPI from '../api/user'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Cookie from 'vue-js-cookie'
import config from '../config/app'
Vue.use(VeeValidate)
Vue.use(Cookie)
export default {
  data: () => {
    return {
      form: {
        code: null,
        password: null,
        re_password: null
      },
      waiting: false,
      showPassword: false,
      showConfirmPassword: false,
      display: {
        message: null
      },
      host: config.host,
      intYear: new Date().getFullYear()
    }
  },
  created () {
    let code = this.$route.params.key
    if (localStorage.getItem('fp_token')) {
      localStorage.removeItem('fp_token')
    }
    userAPI.validateFogotPwLink(code).then((response) => {
      if (response.date_diff === 1) {
        localStorage.setItem('fp_token', '1')
        window.location.href = this.host + '/login'
      } else {
        this.form.code = code
      }
    })
  },
  methods: {
    resetPassword () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          document.getElementById('passerror').style.display = 'block'
          return
        }
        document.getElementById('passerror').style.display = 'none'
        this.waiting = true
        userAPI.confirmResetPassword(this.form).then(() => {
          this.waiting = false
          this.display.message = 'Password changed.'
        })
      })
      return true
    }
  }
}
</script>

<style scoped>
.input-icon {
  position: relative;
  display: inline;
}
img.eye-icon {
  width: 20px;
  position: absolute;
  top: 73%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  user-select: none;
}
  body {
    font-family: 'Ubuntu';
    font-style: normal;
    font-size: 14px;
    font-weight: 300;
  }
  a {
    text-decoration: none !important;
    font-family: 'Ubuntu';
    font-style: normal;
  }
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Brandon Grotesque';
    letter-spacing: 1.2px;
  }
  .login {
      height: 100%;
      min-height: 100vh;
      background-image: url(/static/front/images/login-background.jpg);
      background-size:cover;
  }
  .row {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .login .logo {
      margin: 0 auto;
      text-align: center;
      padding: 5px 35px;
      left: 50%;
  }
  .logo-default {
    width: 150px;
  }
  .login .content{
    background: #00b4eb;
    height: 100%;
    min-height: 100vh;
    border-radius: 0px !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .login .login-content {
    background: #FFFFFF;
    box-shadow: 0px 20px 53px rgba(0, 0, 0, 0.28);
    margin: 0 auto;
    padding: 18px;
    width: 350px;
  }
  .login-content form {
    padding:12px;
  }
  .form-actions {
    text-align: right !important;
  }
  .login .copyright {
      text-align: center;
      margin: 15px;
      color: #FFFFFF;
      font-size: 13px;
  }
  .login .content span.error {
    color: #b94a48;
  }
  .red-btn {
    background: #F6511D;
  }
  .b-btn {
      color: #fff;
      padding: 5px 14px;
      display: inline-block;
      font-weight: 600;
      text-transform: uppercase;
      border: 0;
      font-size: 14px;
      cursor: pointer;
  }
  .login-content [type="password"]{
    border: 1px solid #363537;
    height: 35px;
    width: 100%;
    padding: 0 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    border-radius: 0;
    font-size: 14px;
  }
  .form-title{
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue